import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Schedule from "./components/Schedule";
import MarqueeDivider from "./components/MarqueeDivider";
import VideoSection from "./components/VideoSection";
import LearnGrid from "./components/LearnGrid";
import Curriculum from "./components/Curriculum";
import IncomeProof from "./components/IncomeProof";
import Experience from "./components/Experience";
import Instructor from "./components/Instructor";
import Pricing from "./components/Pricing";
import HowItWorks from "./components/HowItWorks";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";
import StickyCta from "./components/StickyCta";
import LegalPage from "./components/Legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const t = setTimeout(() => {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
          else el.scrollIntoView({ behavior: "smooth" });
        }, 80);
        return () => clearTimeout(t);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Schedule />
        <VideoSection />
        <LearnGrid />
        <MarqueeDivider />
        <Curriculum />
        <IncomeProof />
        <Experience />
        <Instructor />
        <Pricing />
        <HowItWorks />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyCta />
    </>
  );
}

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
        <Route path="/privacy" element={<LegalPage type="privacy" />} />
        <Route path="/refund" element={<LegalPage type="refund" />} />
        <Route path="/contact" element={<LegalPage type="contact" />} />
      </Routes>
    </BrowserRouter>
  );
}
